module.exports = __webpack_public_path__ + "static/media/support2.e9901d2b.png";